//Cette fonction retourne la date d'expiration du cookie de consentement
function getCookieExpireDate(cookieTimeout) {
    // Le nombre de millisecondes que font 13 mois 
    cookieTimeout = cookieTimeout || 33696000000;
    var date = new Date();
    date.setTime(date.getTime() + cookieTimeout);
    var expires = "; expires=" + date.toUTCString();//.toGMTString();
    return expires;
}


function delCookie(name) {
    var path = ";path=" + "/";
    var hostname = document.location.hostname;
    if (hostname.indexOf("www.") === 0)
        hostname = hostname.substring(4);
    var domain = ";domain=" + "." + hostname;
    var expiration = "Thu, 01-Jan-1970 00:00:01 GMT";
    document.cookie = name + "=" + path + domain + ";expires=" + expiration;
}

// Fonction utile pour récupérer un cookie à partir de son nom
function getCookie(NameOfCookie) {
    if (document.cookie.length > 0) {
        var begin = document.cookie.indexOf(NameOfCookie + "=");

        if (begin != -1) {
            begin += NameOfCookie.length + 1;
            var end = document.cookie.indexOf(";", begin);
            if (end == -1) end = document.cookie.length;
            return unescape(document.cookie.substring(begin, end));
        }
    }
    return null;
}


//Récupère la version d'Internet Explorer, si c'est un autre navigateur la fonction renvoie -1
function getInternetExplorerVersion() {
    var rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent;
        var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    } else if (navigator.appName == 'Netscape') {
        var ua = navigator.userAgent;
        var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat(RegExp.$1);
    }
    return rv;
}

//Vérifie la valeur de navigator.DoNotTrack pour savoir si le signal est activé et est à  1
function notToTrack() {
    if ((navigator.doNotTrack && (navigator.doNotTrack == 'yes' || navigator.doNotTrack == '1'))
    /*|| (navigator.msDoNotTrack && navigator.msDoNotTrack == '1')*/) {
        var isIE = (getInternetExplorerVersion() != -1)
        if (!isIE) {
            return true;
        }
        return false;
    }
}

//Si le signal est à  0 on considère que le consentement a déjà  été obtenu
function isToTrack() {
    if (navigator.doNotTrack && (navigator.doNotTrack == 'no')) {
        return true;
    }
}

//Affiche une  bannière d'information en haut de la page
function showCookieConsentBanner() {

    //var bodytag = document.getElementsByTagName('body')[0];
    //var div = document.createElement('div');
    //div.setAttribute('id', 'cookie-banner');
    var consent = window['CookieConsentInstance'] as CookieConsent;
    //div.innerHTML = this.__bannerHtml;
    //$("<div id='cookie-banner'>" + consent.banner.html + "</div>")
    //    .addClass(consent.banner.cssClass)
    //    .appendTo($(consent.banner.container));

    $('body').addClass('cookiebanner');
    var backdrop = document.getElementById("cookie-backdrop");
    if (backdrop) backdrop.style.display = "block";

    //$(this.__container).append(div);
    //document.getElementById(this.__container).appendChild(div);
    //document.getElementsByTagName('body')[0].className += ' cookiebanner';

}


export interface ICookieItem {
    key: string;
    description: string;
    hasConsent(): boolean;
    cookies: string[];
}

export interface CookieConsentEvent { (s, e): void; }

export interface ICookieBanner {
    container: JQuery;
    cssClass: string;
    html: string;
    onAcceptAll: VoidFunction;
    onRejectAll: VoidFunction;

}

export interface ICookieConsentsOptions {

    cookieName: string;

    banner: ICookieBanner;
    cookies: ICookieItem[];
    expiration: number;
    modalConsent: string;
    whiteList: string[];
    blackList: string[];

    showInform: VoidFunction;
    hideInform: VoidFunction;
    checkHasConsented: VoidFunction;

    onInitialize: CookieConsentEvent;
    onStatusChange: CookieConsentEvent;
}

export interface ICookieConsent {
    hasConsented(): boolean;
    isGranted(key: string): boolean;
    start();
}

export class CookieConsent implements ICookieConsent {


    public cookieName: string = "hasConsent";
    public banner: ICookieBanner;
    public cookieItems: ICookieItem[] = [];
    public modalConsent: string = '#modalConsentCookies';

    public whiteList: string[] = [];
    public blackList: string[] = [];

    private __disableStr: string = "";
    private __clickprocessed: boolean = false;
    private __expiration: number = 2592000000; // 1 mois

    private onStatusChange: CookieConsentEvent = (s, e) => { };
    private onInitialize: CookieConsentEvent = (s, e) => { };
    private onReject: CookieConsentEvent = (s, e) => { };

    constructor(options: ICookieConsentsOptions) {

        window['CookieConsentInstance'] = this;// store object into window

        if (options != null) {
            if (typeof options.cookieName === 'string') {
                this.cookieName = options.cookieName;
            }
            if (typeof options.banner === 'object') {
                this.banner = options.banner;
            }

            if (typeof options.cookies === 'object') {
                this.cookieItems = options.cookies;
                this.cookieItems.forEach(c => c.hasConsent = () => this.isGranted(c.key));
            }
            if (typeof options.whiteList === 'object') {
                this.whiteList = options.whiteList;
            }

            if (typeof options.blackList === 'object') {
                this.blackList = options.blackList;
            }

            if (typeof options.modalConsent === 'string') {
                this.modalConsent = options.modalConsent;
            }

            if (typeof options.onInitialize === 'function') {
                this.onInitialize = options.onInitialize;
            }
            if (typeof options.onStatusChange === 'function') {
                this.onStatusChange = options.onStatusChange;
            }
            if (typeof options.showInform === 'function') {
                this.showInform = options.showInform;
            }
            if (typeof options.hideInform === 'function') {
                this.hideInform = options.hideInform
            }
            if (typeof options.checkHasConsented === 'function') {
                this.checkHasConsented = options.checkHasConsented;
            }
            if (typeof options.expiration === 'number') {
                this.__expiration = options.expiration;
            }
        }

        window['CookieConsentInstance'] = this;
    }

    public hasConsented(): boolean {
        return getCookie(this.cookieName) != null;
    }

    // check if cookieGroup has been granted;
    public isGranted(key: string): boolean {
        var cookie = getCookie(this.cookieName);
        if (cookie !== null) {
            return cookie.split(',').indexOf(key) > -1;
        } else {
            return false;
        }
    }

    // check if a cookie or a CookieGroup has been revoked 
    public isRevoked(name: string): boolean {
        for (var i = 0; i < this.cookieItems.length; i++) {
            if (name == this.cookieItems[i].key) {
                return !this.isGranted(name);
            }
            for (var j = 0; j < this.cookieItems[i].cookies.length; j++) {
                if (name == this.cookieItems[i].cookies[j]) {
                    return !this.isGranted(this.cookieItems[i].key);
                }
            }
        }

        return false;
    }

    public saveSettings() {

        var cookieContents = [];

        for (var i = 0; i < this.cookieItems.length; i++) {

            var item = this.cookieItems[i];

            var cb = $("[data-cookie-consent='" + item.key + "']>input");
            var isChecked = cb.prop('checked');
            if (isChecked) {
                cookieContents.push(item.key);
            } else {
                for (var j = 0; j < item.cookies.length; j++) {
                    delCookie(item.cookies[j].trim());
                }
            }
        }
        document.cookie = this.cookieName + '=' + cookieContents + '; ' + getCookieExpireDate(this.__expiration) + ' ; path=/';
        this.onStatusChange(this, cookieContents);
        this.hideInform();
    }

    public rejectAll() {

        var cookieContents = [];
        document.cookie = this.__disableStr + '=true;' + getCookieExpireDate(this.__expiration) + ' ; path=/';
        document.cookie = this.cookieName + '=' + cookieContents + '; ' + getCookieExpireDate(this.__expiration) + ' ; path=/';

        window[this.__disableStr] = true;
        this.__clickprocessed = true;

        for (var i = 0; i < this.cookieItems.length; i++) {

            var item = this.cookieItems[i];

            var cb = $(item).find('input');
            cb.prop('checked', false);

            var cb2 = $("[data-cookie-consent='" + item.key + "']>input");
            cb2.prop('checked', true);

            for (var j = 0; j < item.cookies.length; j++) {
                delCookie(item.cookies[j].trim());
            }
        }
        this.onStatusChange(this, cookieContents);
        this.hideInform();
    }

    public acceptAll() {

        var cookieContents = [];

        for (var i = 0; i < this.cookieItems.length; i++) {

            var item = this.cookieItems[i];

            cookieContents.push(item.key);

            var cb = $("[data-cookie-consent='" + item.key + "']>input");
            cb.prop('checked', true);

        }

        document.cookie = this.cookieName + '=' + cookieContents + '; ' + getCookieExpireDate(this.__expiration) + ' ; path=/; Secure; SameSite=none';

        this.onStatusChange(this, cookieContents);
        this.hideInform();
    }

    private delRejected() {
        for (var i = 0; i < this.cookieItems.length; i++) {
            var item = this.cookieItems[i];
            var key = item.key;
            if (!item.hasConsent()) {
                for (var j = 0; j < item.cookies.length; j++) {
                    delCookie(item.cookies[j].trim());
                }
            }
        }
    }


    public showInform() {

        ($(this.modalConsent) as any).modal("show");
        $(this.modalConsent).on('hidden.bs.modal', function (e) {
            if ($('.modal:visible').length) {
                $('body').addClass('modal-open');
            }
        });

        this.checkHasConsented();
    }

    public checkHasConsented() {
        if (this.hasConsented()) {
            for (var i = 0; i < this.cookieItems.length; i++) {
                var item = this.cookieItems[i];
                var cb = $("[data-cookie-consent='" + item.key + "']>input");
                cb.prop("checked", item.hasConsent());
            }
        }
    }

    public hideInform() {
        var div = document.getElementById("cookie-banner");
        var backdrop = document.getElementById("cookie-backdrop");
        if (div) div.style.display = "none";
        if (backdrop) backdrop.style.display = "none";

        //($(this.modalConsent) as any).modal("hide");
    }


    public start() {
        if (navigator.cookieEnabled == true) {
            //console.info("navigator cookies are enabled");

            $('a[href="#CookieConsent"]').on('click', function () {
                $('#modalConsentCookies').modal("show");
            });

        } else {
            console.warn("navigator cookies are disabled");
        }

        //On vérifie que le consentement n'a pas déjà été obtenu avant d'afficher la bannière
        var consentCookie = getCookie(this.cookieName);
        //var cookieContents = [];
        //if (consentCookie !== null) {
        //    cookieContents = consentCookie.split(',');
        //}

        var clickprocessed = false;
        if (consentCookie === null) {

            $('#cookie-banner').addClass('bounceInUp').removeClass('d-none');

            //L'utilisateur n'a pas encore de cookie, on affiche la bannià©re. 
            //Si il clique sur un autre élément que la bannière on enregistre le consentement
            if (notToTrack()) {
                //L'utilisateur a activé DoNotTrack. Do not ask for consent and just opt him out
                this.rejectAll()
                console.log("You've enabled DNT, we're respecting your choice")
            } else {



                if (window.addEventListener) {
                    window.addEventListener("load", showCookieConsentBanner, false);
                    //document.addEventListener("click", consent, false);
                } else {
                    window.onload = showCookieConsentBanner;

                    //document.attachEvent("onclick", consent);
                }
            }
        } else {

            this.onInitialize(this, null);// callGoogleAnalytics();
            this.hideInform();
            //    else window[this.__disableStr] = true;

            // supprime les cookie non accéptés
            this.delRejected();
        }

        // cookie interceptor 
        var cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
            Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
        if (cookieDesc && cookieDesc.configurable) {
            Object.defineProperty(document, 'cookie', {
                get: function () {
                    return cookieDesc.get.call(document);
                },
                set: function (val) {
                    if (val.indexOf("=") > 0) {
                        var nameOfCookie = unescape(val.substring(0, val.indexOf("=")));
                        if (nameOfCookie.length > 0) {
                            var consent = window['CookieConsentInstance'] as CookieConsent
                            if (consent.whiteList.indexOf(nameOfCookie) < 0) {
                                if (consent.blackList.indexOf(nameOfCookie) >= 0 || consent.isRevoked(nameOfCookie)) {
                                    // bloque le cookie
                                    console.log('cookie ' + val + ' rejected by CookieConsent');
                                    consent.onReject(consent, nameOfCookie);
                                    return;
                                }
                            }
                        }
                    }

                    cookieDesc.set.call(document, val);
                }
            });
        }
    }
}

window.CookieConsent = CookieConsent;


